// extracted by mini-css-extract-plugin
module.exports = {"heading":"e_WF","title":"e_XF","toTopButton":"e_YF","toTopButtonIcon":"e_ZF"};